module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['catalog', _vm.avatarIcon ? 'icon-wrapper' : 'simple-mode', _vm.hasMargin && 'catalog-margin'],
    style: ({
      backgroundColor: _vm.backgroundColor
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.avatarIcon) ? _c('figure', {
    staticClass: "left-icon weex-el weex-image",
    attrs: {
      "src": _vm.imagePath,
      "data-img-src": _vm.imagePath,
      "weex-type": "image"
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.textStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-95fb6ed8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95fb6ed8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-catalog/index.vue
// module id = 646
// module chunks = 0 1